<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.viewBox]="viewBox"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.1748 0C11.1373 6.59702e-05 14.3495 3.2123 14.3496 7.1748C14.3496 11.1374 11.1374 14.3495 7.1748 14.3496C3.21226 14.3495 0 11.1374 0 7.1748C6.59713e-05 3.2123 3.2123 6.59721e-05 7.1748 0ZM2.26172 10.9141C3.38977 12.3939 5.17039 13.3496 7.1748 13.3496C10.5851 13.3495 13.3496 10.5851 13.3496 7.1748C13.3496 6.32854 13.1782 5.52245 12.8701 4.78809L2.26172 10.9141ZM7.1748 1C3.76458 1.00007 1.00007 3.76458 1 7.1748C1 8.22169 1.26096 9.20741 1.7207 10.0713L12.4082 3.90039C11.3164 2.15902 9.38176 1.00004 7.1748 1Z"
    fill="#C4C4C4"
  />
</svg>
